import type { ImportInfo, ImportStatus } from '@mcgames/contracts';

type Translate = (key: string, options?: Record<string, string>) => string;

/** "Running: check", "Needs review: no unique store match", ... */
export function importStatusText(t: Translate, info: ImportInfo): string {
  const reason = t(`indexer.reason.${info.reason ?? 'unknown'}`);
  return t(`indexer.status.${info.status}`, { step: t(`indexer.step.${info.step}`), reason });
}

/**
 * Why the import stopped, in the API's words; null when there is nothing to add (the title of an
 * `already_in_catalog` duplicate is shown as the existing game instead).
 */
export function importReasonDetail(info: ImportInfo): string | null {
  return info.reason === null || info.reason === 'already_in_catalog' ? null : info.reasonDetail;
}

/** Badge tone of an import status: stopped ones stand out, finished ones are accented. */
export function importStatusTone(status: ImportStatus): 'default' | 'accent' | 'danger' {
  if (status === 'failed') return 'danger';
  return status === 'running' || status === 'needs_review' ? 'default' : 'accent';
}
